import React, { useState } from "react";
import config from "../../config/enviroment";

const icons = {
  error: config.urlMultimedia+'/vende/landing-img/error.svg',
  success: config.urlMultimedia+'/vende/landing-img/success.svg',
  warning: config.urlMultimedia+'/vende/landing-img/warning.svg',
  info: config.urlMultimedia+'/vende/landing-img/info.svg',
};

const themes = {
  error: { bg: "#FEF2F2", border: "#FECACA", text: "#000" },
  success: { bg: "#F0FDF4", border: "#BBF7D0", text: "#166534" },
  warning: { bg: "#FFFBEB", border: "#FDE68A", text: "#92400E" },
  info: { bg: "#EFF6FF", border: "#BFDBFE", text: "#1E40AF" },
};

type MessageType = "error" | "success" | "warning" | "info";

interface MessageProps {
  type?: MessageType;
  title?: string;
  description?: string;
  dismissible?: boolean;
  onDismiss?: () => void;
}

const Message = ({ type = "error", title, description, dismissible = true, onDismiss }: MessageProps) => {
  const [visible, setVisible] = useState(true);
  const [exiting, setExiting] = useState(false);

  const theme = themes[type];

  if (!visible) return null;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "14px 16px",
        borderRadius: "10px",
        border: `1.5px solid ${theme.border}`,
        backgroundColor: theme.bg,
        color: theme.text,
        fontFamily: "'Segoe UI', sans-serif",
        fontSize: "15px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "1.55",
        boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
        position: "relative",
        opacity: exiting ? 0 : 1,
        transform: exiting ? "translateY(-6px)" : "translateY(0)",
        transition: "opacity 0.3s ease, transform 0.3s ease",
        marginBottom: "10px"
      }}
    >
      <span style={{ flexShrink: 0, marginTop: "1px" }}>
        <img src={icons[type]} alt={type} width={20} height={20} />
      </span>
      <div style={{ flex: 1 }}>
        {title && (
          <div style={{ fontWeight: 700, marginBottom: description ? "3px" : 0 }}>
            {title}
          </div>
        )}
        {description && <div style={{ opacity: 0.9 }}>{description}</div>}
      </div>
    </div>
  );
};

export default Message;